import { render, staticRenderFns } from "./facialVisitsReport.vue?vue&type=template&id=a143b5e4&scoped=true"
import script from "./facialVisitsReport.vue?vue&type=script&lang=js"
export * from "./facialVisitsReport.vue?vue&type=script&lang=js"
import style0 from "./facialVisitsReport.vue?vue&type=style&index=0&id=a143b5e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a143b5e4",
  null
  
)

export default component.exports